import {
  getBlockInfo,
  checkBlock,
  getContacts,
  setBlockOneType,
  checkBlockOneType,
} from '@/API/user.js';
import { debounce } from '@/services/request';
import store from '@/newApplication/store';

export const BlockNames = {
  block: 'FULL',
  blockBsma: 'BSMA',
  blockDopMag: 'DOP_MAG',
  blockPostgraduate: 'POSTGRADUATE',
  blockInternship: 'INTERNSHIP',
  blockPaidBsm: 'PAID_BSM',
  blockPaidInternship: 'PAID_INTERNSHIP',
  blockPaidAssist: 'PAID_ASSIST',
  blockPaidPostgraduate: 'PAID_POSTGRADUATE',
  blockAppDeadline: 'APPDEADLINE',
  blockTargetQuotaBsma: 'TARGET_QUOTA_BSMA',
  blockTargetQuotaPostgraduate: 'TARGET_QUOTA_POSTGRADUATE',
  blockTargetQuotaInternship: 'TARGET_QUOTA_INTERNSHIP',
  blockDviNumber: 'DVI_NUMBER'
};
export default {
  namespaced: true,
  state: {
    checkFilledContacts: false,
    contact: null,
    block: {
      FULL: false,
      BSMA: false,
      DOP_MAG: false,
      POSTGRADUATE: false,
      INTERNSHIP: false,
      PAID_BSM: false,
      PAID_ASSIST: false,
      PAID_POSTGRADUATE: false,
      PAID_INTERNSHIP: false,
      APPDEADLINE: false,
      TARGET_QUOTA_BSMA: false,
      TARGET_QUOTA_POSTGRADUATE: false,
      TARGET_QUOTA_INTERNSHIP: false,
      DVI_NUMBER: false
    },
    canBlock: {
      FULL: { value: false, messages: [], message: '' },
      BSMA: { value: false, messages: [], message: '' },
      DOP_MAG: { value: false, messages: [], message: '' },
      POSTGRADUATE: { value: false, messages: [], message: '' },
      INTERNSHIP: { value: false, messages: [], message: '' },
      PAID_BSM: { value: false, messages: [], message: '' },
      PAID_ASSIST: { value: false, messages: [], message: '' },
      PAID_POSTGRADUATE: { value: false, messages: [], message: '' },
      PAID_INTERNSHIP: { value: false, messages: [], message: '' },
      APPDEADLINE: { value: false, messages: [], message: '' },
      TARGET_QUOTA_BSMA: { value: false, messages: [], message: '' },
      TARGET_QUOTA_POSTGRADUATE: { value: false, messages: [], message: '' },
      TARGET_QUOTA_INTERNSHIP: { value: false, messages: [], message: '' },
      DVI_NUMBER: { value: false, messages: [], message: '' }
    },
  },
  mutations: {
    ['ADD_STATUS_CHECK_FILLED_CONTACTS'](state, payload) {
      state.checkFilledContacts = payload;
    },
    ['ADD_CONTACTS'](state, payload) {
      state.contact = payload;
    },
    ['SET_BLOCK_STATUS'](state, payload) {
      Object.keys(state.block).forEach((el) => {
        state.block[el] = payload[el];
      });
    },
    ['SET_BLOCK_STATUS_SINGLE'](state, payload = { type: '', value: true }) {
      const { type, value } = payload;
      if (type && [true, false].includes(value)) state.block[type] = value;
      else console.error('invalid typ e & value'.type, value);
    },
    //TODO: rewrtie to new requset
    ['SET_BLOCK_ALLOW'](state, payload) {
      Object.keys(state.canBlock).forEach((el) => {
        state.canBlock[el] = payload[el] ?? state.canBlock[el];
      });
    },
    ['SET_BLOCK_ALLOW_SINGLE'](
      state,
      payload = { type: '', value: true, messages: [], message: '' },
    ) {
      const { type, value, messages, message } = payload;
      if (type && [true, false].includes(value)) {
        state.canBlock[type].value = value;
        state.canBlock[type].messages = messages;
        state.canBlock[type].message = message;
      } else console.error('invalid typ e & value'.type, value);
    },
  },
  actions: {
    fetchCheckFilled({ commit }, payload) {
      const { contacts } = payload;
      if (
        Array.isArray(contacts) &&
        contacts &&
        contacts.length === 2 &&
        contacts[0].fio.length > 0
      ) {
        commit('ADD_STATUS_CHECK_FILLED_CONTACTS', true);
        return true;
      } else if (
        contacts &&
        contacts?.position &&
        contacts?.fio?.length > 0 &&
        contacts.email.length > 0 &&
        contacts.position.length > 0
      ) {
        commit('ADD_STATUS_CHECK_FILLED_CONTACTS', true);
        commit('ADD_CONTACTS', contacts);
        return true;
      } else {
        commit('ADD_CONTACTS', contacts);
        return false;
      }
    },
    loadingBlockInfo({ commit }) {
      let year = '2024';
      let type = 'org';
      if (store.getters.selectedYear) year = store.getters.selectedYear;
      let id;
      const typesContact = {
        org: 'org',
      };
      if (store.getters['keycloak/getUser']?.orgID) {
        id = store.getters['keycloak/getUser']?.orgID;
        type = store.getters['keycloak/getUser']?.orgID ? 'org' : type;
      }
      if (store.getters['keycloak/getFakeUser']) {
        id = store.getters['keycloak/getFakeUser']?.id;
        type = store.getters['keycloak/getFakeUser'].role === 'ORGANIZATION_ROLE' ? 'org' : type;
      }
      if (!typesContact[type] || (!id && !store.getters['keycloak/getFakeUser'])) return;
      if (!typesContact[type] || !id) throw new Error('type contact invalid can be org');
      const getBlockInfoLocal = () =>
        getBlockInfo(year, id).then((data) => {
          if (!data) return;
          const mappedData = Object.entries(BlockNames).reduce((acc, [key, value]) => {
            acc[value] = data[key] ?? false;
            return acc;
          }, {});
          commit('SET_BLOCK_STATUS', mappedData);
        });
      debounce(getBlockInfoLocal)();
    },
    loadingAllowBlockInfo({ commit }) {
      let year = '2024';
      let type = 'org';
      if (store.getters.selectedYear) year = store.getters.selectedYear;
      let id;
      const typesContact = {
        org: 'org',
      };
      if (store.getters['keycloak/getUser']?.orgID) {
        id = store.getters['keycloak/getUser']?.orgID;
      }
      if (store.getters['keycloak/getFakeUser']) {
        id = store.getters['keycloak/getFakeUser']?.id;
      }
      if (!typesContact[type] || (!id && !store.getters['keycloak/getFakeUser'])) return;
      if (!typesContact[type] || !id) throw new Error('type contact invalid can be org');

      const checkBlockLocal = () =>
        checkBlock(id, year).then((data) => {
          const mappedData = {};
          data.forEach((el) => {
            mappedData[el.blockType] = {
              value: el.canBlock,
              messages: el.messages,
              message: '',
              sumKcp: el.sumKcp,
              sumDistributed: el.sumDistributed,
            };
          });
          commit('SET_BLOCK_ALLOW', mappedData);
        });
      // eslint-disable-next-line no-unreachable
      debounce(checkBlockLocal)();
    },
    /**
     * @param commit
     * @param {{type: string, value: boolean}} payload
     * */
    async blockOneType({ commit }, payload) {
      let year = '2024';
      let id;
      if (store.getters.selectedYear) year = store.getters.selectedYear;
      if (store.getters['keycloak/getUser']?.orgID) id = store.getters['keycloak/getUser']?.orgID;
      if (store.getters['keycloak/getFakeUser']) id = store.getters['keycloak/getFakeUser']?.id;
      await setBlockOneType(payload.type, id, year);
      commit('SET_BLOCK_STATUS_SINGLE', payload);
    },
    /**
     * @param commit
     * @param {string} type
     * */
    checkBlockOneType({ commit }, type) {
      let id;
      let year = '2024';
      if (store.getters.selectedYear) year = store.getters.selectedYear;
      if (store.getters['keycloak/getUser']?.orgID) id = store.getters['keycloak/getUser']?.orgID;
      if (store.getters['keycloak/getFakeUser']) id = store.getters['keycloak/getFakeUser']?.id;
      checkBlockOneType(type, id, year)
        .then((data) =>
          commit('SET_BLOCK_ALLOW_SINGLE', {
            type: type,
            value: data.canBlock,
            messages: data.messages,
            message: data.message,
          }),
        )
        .catch((e) => console.error('checkBlockOneType', e));
    },
    async getContact({ dispatch }) {
      const getContactLocal = async () => {
        let id;
        let year = '2024';
        if (store.getters.selectedYear) year = store.getters.selectedYear;
        if (store.getters['keycloak/getUser']?.orgID) id = store.getters['keycloak/getUser']?.orgID;
        if (store.getters['keycloak/getFakeUser']) id = store.getters['keycloak/getFakeUser']?.id;
        try {
          const res = await getContacts(id, year);

          if (res && res[0] && res[1]) {
            return await dispatch('fetchCheckFilled', { contacts: res });
          }
          return false;
        } catch (e) {
          console.error('getContact dispatch', e);
          throw new Error(e);
        }
      };
      return await getContactLocal();
    },
  },
  getters: {
    get_check_filled_status(state) {
      return state.checkFilledContacts;
    },
    get_contact_data(state) {
      return state.contact;
    },
    getAdminInfo(state) {
      return state.adminInfo;
    },
    currentStage(state) {
      return Number.parseInt(state.adminInfo?.stage) ?? 1;
    },
    getFilesList(state) {
      return state.files;
    },
    getFilesListStatus(state) {
      return state.filesLoading;
    },
    getBlockStatus(state) {
      return state.block;
    },
    getBlockStatusEdit(state) {
      return state.canBlock;
    },
  },
};
